import { createSlice } from '@reduxjs/toolkit';

import { actions } from './actions';
import { IModalInitial } from './types';

const initialState: IModalInitial = {
  tag: '',
  isOpen: false,
};

const modalSlice = createSlice({
  name: 'modalSlice',
  initialState,
  reducers: actions,
});

export const modalReducer = modalSlice.reducer;
export const { showModal, closeModal } = modalSlice.actions;
